(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name webAgro1App.AdubacoesService
   * @description
   * # AdubacoesService
   * Factory in the webAgro1App.
   */
  angular
    .module('webAgro1App')
    .factory('AdubacoesService', AdubacoesService);

  AdubacoesService.$inject = [
    '$http',
    '$rootScope'
  ];

  // eslint-disable-next-line max-lines-per-function
  function AdubacoesService($http, $rootScope) {
    //////////////////////////////////////////
    // Service data

    //////////////////////////////////////////
    // Service object declaration
    const service = {
      list: List,
      getStatusAdubacaoGlebas: GetStatusAdubacaoGlebas,
      get: Get,
      delete: Delete
    };
    return service;

    //////////////////////////////////////////
    // Function declarations

    // eslint-disable-next-line complexity
    function GetFilters(filters) {
      return !filters ? {} : {
        data_inicial: filters.dataInicial || null,
        data_final: filters.dataFinal || null,
        page: filters.page || null,
        gleba: (filters.gleba || {}).id || null,
        operacao: $rootScope.parametros.operacao_adubacao.id,
        epoca: (filters.epoca || {}).codigo,
        status: filters.status || null
      };
    }

    function List(filters) {
      const params = GetFilters(filters);
      return $http.get(`${SERVER}v1/aplicacoes/simple`, { params: params });
    }

    function GetStatusAdubacaoGlebas(filters) {
      return $http.get(`${SERVER + API_VERSION}aplicacoes_status_glebas`, { params: GetFilters(filters) });
    }

    function Get(id) {
      return $http.get(`${SERVER}v1/aplicacoes/${id}`);
    }

    function Delete(id) {
      return $http.delete(`${SERVER}v1/aplicacoes/${id}`);
    }
  }
}());
